import { Filter } from "@/models/Pageable"
import { ToDoItemType, ToDoRelatedResource, ToDoStatus } from "@/models/ToDo"

export interface ToDoUserCompletionQuery {
  userId: string
  completed: boolean
}

export class FilterToDo extends Filter {
  completedByMe?: boolean
  createdByMe?: boolean
  myTodos?: boolean
  label?: string
  q?: string
  relatedResource?: ToDoRelatedResource
  status?: ToDoStatus
  excludedStatuses?: ToDoStatus[]
  type?: ToDoItemType
  userCompletionQuery?: ToDoUserCompletionQuery
  startCreatedDate?: string
  endCreatedDate?: string
  urgent?: boolean
  today?: boolean
  pastDue?: boolean

  constructor(props?: Partial<FilterToDo>) {
    super(props as FilterToDo)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }
  /** Serializes the shared ToDo query and can omit only its pagination fields for metrics requests. */
  getJsonObj({ withoutPagination = false }: { withoutPagination?: boolean } = {}) {
    const data = {
      completedByMe: this.completedByMe,
      createdByMe: this.createdByMe,
      myTodos: this.myTodos,
      label: this.label,
      q: this.q,
      status: this.status,
      excludedStatuses: this.excludedStatuses,
      type: this.type,
      startCreatedDate: this.startCreatedDate,
      endCreatedDate: this.endCreatedDate,
      urgent: this.urgent,
      today: this.today,
      pastDue: this.pastDue,
      relatedResource: this.relatedResource,
      userCompletionQuery: this.userCompletionQuery
    }
    return super.getJsonObj({ params: data, withoutPagination })
  }
}

export class FilterToDoCount {
  completedByMe?: boolean = undefined
  createdByMe?: boolean = undefined
  label?: string = undefined
  q?: string = undefined
  relatedResource?: ToDoRelatedResource = undefined
  status?: ToDoStatus = undefined

  constructor(props?: Partial<FilterToDoCount>) {
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }
  getJsonObj() {
    const params = new URLSearchParams()
    const data = {
      completedByMe: this.completedByMe,
      createdByMe: this.createdByMe,
      label: this.label,
      q: this.q,
      status: this.status
    }
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined) params.append(key, String(value))
    })
    appendNestedQuery(params, "relatedResource", this.relatedResource)
    return params
  }
}

function appendNestedQuery(params: URLSearchParams, prefix: string, value?: object) {
  if (!value) return
  Object.entries(value).forEach(([key, fieldValue]) => {
    if (fieldValue !== undefined && fieldValue !== null && fieldValue !== "") {
      params.append(`${prefix}.${key}`, String(fieldValue))
    }
  })
}
